import { useRequiredParams } from '@pba/react-router';
import { GroupEntities, GroupLayout } from 'features/groups';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { isGroupScope } from 'features/groups/models';
import { AuthenticatedNotFound } from '../../authenticated-not-found';
import { useGetPathToEntityDetail } from '../../hooks';

type RoutingParams = {
  groupId: string;
  scope: string;
};

const PageGroupsList = () => {
  const { groupId, scope } = useRequiredParams<RoutingParams>();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  if (!isGroupScope(scope)) {
    return <AuthenticatedNotFound />;
  }

  return (
    <GroupLayout groupId={groupId}>
      {(group) => <GroupEntities entityScope={scope} getPathToDetail={getPathToEntityDetail} group={group} />}
    </GroupLayout>
  );
};

export default PageGroupsList;
